import gql from "graphql-tag";

export const WWW_COUNTRY_CODES = gql`
  query CountryCodes($requiredStatesFor: [String!]) {
    countryCodes(requiredStatesFor: $requiredStatesFor) {
      alpha2
      alpha3
      name
      code
      states {
        name
        alpha2
      }
    }
  }
`;

export const WWW_LEASE_INQUIRY_MUTATION = gql`
  mutation createFlexLeaseInquiry(
    $listingId: ID
    $firstName: String!
    $lastName: String!
    $phone: String!
    $dealBreakers: String!
    $email: String!
    $moveInOn: String
    $moveOutOn: String
    $occupation: String!
    $sleeps: Int
    $city: String
    $bedrooms: Int
    $utmSource: String
    $utmMedium: String
    $utmCampaign: String
    $utmContent: String
    $utmTerm: String
    $initialReferrer: String
    $source: String
  ) {
    createFlexLeaseInquiry(
      listingId: $listingId
      firstName: $firstName
      lastName: $lastName
      phone: $phone
      dealBreakers: $dealBreakers
      email: $email
      moveInOn: $moveInOn
      moveOutOn: $moveOutOn
      occupation: $occupation
      sleeps: $sleeps
      city: $city
      bedrooms: $bedrooms
      utmSource: $utmSource
      utmMedium: $utmMedium
      utmCampaign: $utmCampaign
      utmContent: $utmContent
      utmTerm: $utmTerm
      initialReferrer: $initialReferrer
      source: $source
    ) {
      response {
        success
        error
        trackingInfo
      }
    }
  }
`;
